import { createSlice } from '@reduxjs/toolkit';

const competitionCategories = createSlice({
  name: 'competitionCategories',
  initialState: [],
  reducers: {
    setCompetitionCategories(state, action) {
      return action.payload;
    }
  }
});

export const { setCompetitionCategories } = competitionCategories.actions;
export default competitionCategories.reducer;